<div class="icon-bar-container {{iconBarData.theme}}" *ngIf="iconBarData">
    <div class="icon-bar {{iconBarData.theme}}">
        <finder-font-icon
            hexValue="{{iconBarData.icon}}"
            [svgSrc]="iconBarData.src"
            size="inherit">
        </finder-font-icon>
    </div>
</div>
